import { useEffect, useState } from "react";

export const useAdblockDetect = () => {
    const [isAdblockEnabled, setIsAdblockEnabled] = useState(false);

    useEffect(() => {
        // Use `fetch` with `no-cors` mode so we can verify that use is not blocking our analytics scripts
        const url = "https://www.google-analytics.com/analytics.js";
        fetch(url, {
            method: "HEAD",
            mode: "no-cors",
            cache: "no-store",
        }).catch(() => {
            // TODO: Need better language. Inform Anush, Scott + CS
            setIsAdblockEnabled(true);
            console.log("%c Script Blocker detected. Please whitelist Xola.com", "background-color:red;color:white");
            console.log("so Xola can continue functioning effectively");
            console.log("Please see https://www.xola.com/privacy-policy for more information");
        });
    }, []);

    return isAdblockEnabled;
};
